import React from "react";
import PersonalDataStepShared from "../../common/components/PersonalDataStep/PersonalDataStepShared";

/**
 * Temporary-storage customer-data step. Thin wrapper over the shared,
 * prop-gated {@link PersonalDataStepShared} (issue #868). Storage collects only
 * the base fields (name / email / phone, + USC for USC partners) and links its
 * terms to the generic `/hints` page. Unlike SUP / product rental it does NOT
 * auto-agree on mount, so `showAgreement` is omitted.
 *
 * Note: segmenta gates this step off in its booking flow (employees are
 * resolved from Entra ID), so this screen is only shown for the neighbourhood
 * storage tenants (e.g. Vonovia, dhu).
 */
const PersonalDataStep = () => <PersonalDataStepShared />;

export default PersonalDataStep;
